module.exports = __webpack_public_path__ + "img/sleeping-bot-avatar.dcb02ee8.png";